var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-view"},[_c('app-header',{attrs:{"icon":"home","title":"Início"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }